export default "__VITE_ASSET__ClopDVll__"